import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../contexts/CartContext";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { DISPLAY_LANG } from "../../config";
import { errorMessage } from '../../api/global';

export default function CartHostings() {
    const { orders, cursorLoad, updateHosintgBillingTpye, removeFromCart } = useContext(CartContext);
    const { selectedCurrency } = useContext(CurrencyContext);
    const [openSelectId, setOpenSelectId] = useState(null);


    const selectOptions = {
        monthly: {
            en: 'Monthly',
            am: 'Ամսական',
            ru: 'Ежемесячно',
        },
        yearly: {
            en: 'Yearly',
            am: 'Տարեկան',
            ru: 'Ежегодно',
        },
    }


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".select")) {
                setOpenSelectId(null);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);


    const handleSelectChange = async (id, value) => {
        try {
            await updateHosintgBillingTpye(id, value);
            setOpenSelectId(null);
        } catch (error) {
            console.log(error);
            alert(errorMessage[DISPLAY_LANG])
        }
    };

    const handleRemoveHostingInCart = async (id) => {
        try {
            await removeFromCart(id);
        } catch (error) {
            console.log(error);
            alert(errorMessage[DISPLAY_LANG]);
        }
    };

    console.log('orders in cart hostings: ', orders);

    return orders.map((elem, index) => elem.item_type === 'hosting' && (
        <div className="order flex-between" key={index}>

            <div className="left-side">
                <h3>{elem.isp_hosting_name}</h3>

                <div
                    className={`select ${openSelectId === elem.id ? "open" : ""}`}
                    style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                >
                    <p
                        className="selected-option"
                        style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                        onClick={() =>
                            setOpenSelectId(openSelectId === elem.id ? null : elem.id)
                        }
                    >
                        {
                            elem.isp_hosting_billing_type === 'monthly'
                                ? selectOptions.monthly[DISPLAY_LANG]
                                : selectOptions.yearly[DISPLAY_LANG]
                        }
                    </p>

                    <div className="dropdown">
                        <p
                            style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                            onClick={() => {
                                handleSelectChange(elem.id, 'monthly');
                            }}
                        >
                            {selectOptions.monthly[DISPLAY_LANG]}
                        </p>

                        <p
                            style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                            onClick={() => {
                                handleSelectChange(elem.id, 'yearly');
                            }}
                        >
                            {selectOptions.yearly[DISPLAY_LANG]}
                        </p>
                    </div>
                </div>
            </div>


            <div className="right-side flex-center">
                {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}

                <div className='price'>
                    {(Math.ceil(elem.isp_hosting_price[elem.isp_hosting_billing_type][selectedCurrency.title])).toFixed(2)}
                </div>

                {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}

                <img
                    src="/images/domains/trash.svg"
                    alt="trash"
                    onClick={() => handleRemoveHostingInCart(elem.id)}
                    style={{ cursor: cursorLoad ? 'wait' : '' }}
                />
            </div>

        </div>
    ))
}
